import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";
import { PAYMENT_TERM } from "./apiRoutes";

interface getProps {
  communityId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getPaymentTermsIncludeDelete = async (communityId: string) => await axiosAuth.get(`${PAYMENT_TERM}/community/${communityId}/including-deleted`);

const useGetPaymentTermsIncludeDelete = ({
  communityId,
  queryParams
}: getProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["payment-terms"],
    queryFn: () => getPaymentTermsIncludeDelete(communityId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!communityId && (queryParams?.enabled ?? true),
  });
};

export default useGetPaymentTermsIncludeDelete;
